import _classCallCheck from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _get from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/get";
import _inherits from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { Factory } from '../Factory.js';
import { Shape } from '../Shape.js';
import { Animation } from '../Animation.js';
import { getNumberValidator } from '../Validators.js';
import { _registerNode } from '../Global.js';
export var Sprite =
/*#__PURE__*/
function (_Shape) {
  _inherits(Sprite, _Shape);

  function Sprite(config) {
    var _this;

    _classCallCheck(this, Sprite);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Sprite).call(this, config));
    _this._updated = true;
    _this.anim = new Animation(function () {
      var updated = _this._updated;
      _this._updated = false;
      return updated;
    });

    _this.on('animationChange.konva', function () {
      this.frameIndex(0);
    });

    _this.on('frameIndexChange.konva', function () {
      this._updated = true;
    });

    _this.on('frameRateChange.konva', function () {
      if (!this.anim.isRunning()) {
        return;
      }

      clearInterval(this.interval);

      this._setInterval();
    });

    return _this;
  }

  _createClass(Sprite, [{
    key: "_sceneFunc",
    value: function _sceneFunc(context) {
      var anim = this.animation(),
          index = this.frameIndex(),
          ix4 = index * 4,
          set = this.animations()[anim],
          offsets = this.frameOffsets(),
          x = set[ix4 + 0],
          y = set[ix4 + 1],
          width = set[ix4 + 2],
          height = set[ix4 + 3],
          image = this.image();

      if (this.hasFill() || this.hasStroke()) {
        context.beginPath();
        context.rect(0, 0, width, height);
        context.closePath();
        context.fillStrokeShape(this);
      }

      if (image) {
        if (offsets) {
          var offset = offsets[anim],
              ix2 = index * 2;
          context.drawImage(image, x, y, width, height, offset[ix2 + 0], offset[ix2 + 1], width, height);
        } else {
          context.drawImage(image, x, y, width, height, 0, 0, width, height);
        }
      }
    }
  }, {
    key: "_hitFunc",
    value: function _hitFunc(context) {
      var anim = this.animation(),
          index = this.frameIndex(),
          ix4 = index * 4,
          set = this.animations()[anim],
          offsets = this.frameOffsets(),
          width = set[ix4 + 2],
          height = set[ix4 + 3];
      context.beginPath();

      if (offsets) {
        var offset = offsets[anim];
        var ix2 = index * 2;
        context.rect(offset[ix2 + 0], offset[ix2 + 1], width, height);
      } else {
        context.rect(0, 0, width, height);
      }

      context.closePath();
      context.fillShape(this);
    }
  }, {
    key: "_useBufferCanvas",
    value: function _useBufferCanvas() {
      return _get(_getPrototypeOf(Sprite.prototype), "_useBufferCanvas", this).call(this, true);
    }
  }, {
    key: "_setInterval",
    value: function _setInterval() {
      var that = this;
      this.interval = setInterval(function () {
        that._updateIndex();
      }, 1000 / this.frameRate());
    }
  }, {
    key: "start",
    value: function start() {
      if (this.isRunning()) {
        return;
      }

      var layer = this.getLayer();
      this.anim.setLayers(layer);

      this._setInterval();

      this.anim.start();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.anim.stop();
      clearInterval(this.interval);
    }
  }, {
    key: "isRunning",
    value: function isRunning() {
      return this.anim.isRunning();
    }
  }, {
    key: "_updateIndex",
    value: function _updateIndex() {
      var index = this.frameIndex(),
          animation = this.animation(),
          animations = this.animations(),
          anim = animations[animation],
          len = anim.length / 4;

      if (index < len - 1) {
        this.frameIndex(index + 1);
      } else {
        this.frameIndex(0);
      }
    }
  }]);

  return Sprite;
}(Shape);
Sprite.prototype.className = 'Sprite';

_registerNode(Sprite);

Factory.addGetterSetter(Sprite, 'animation');
Factory.addGetterSetter(Sprite, 'animations');
Factory.addGetterSetter(Sprite, 'frameOffsets');
Factory.addGetterSetter(Sprite, 'image');
Factory.addGetterSetter(Sprite, 'frameIndex', 0, getNumberValidator());
Factory.addGetterSetter(Sprite, 'frameRate', 17, getNumberValidator());
Factory.backCompat(Sprite, {
  index: 'frameIndex',
  getIndex: 'getFrameIndex',
  setIndex: 'setFrameIndex'
});